const intervalId = setInterval(async () => {
    if (window.tlProductBundle) {
        clearInterval(intervalId);

        if (window.location.pathname === "/cart") return;

        window.addEventListener("TL-PRODUCTBUNDLE:add", async (e) => {
            const cartItemsSelector = window.location.pathname === "/cart" ? "cart-items" : "cart-drawer-items";
            const cartItemsElement = document.querySelector(cartItemsSelector);
            const sectionsToReRender = cartItemsElement.getSectionsToRender();

            const response = await fetch(`/?sections=${sectionsToReRender.map((s) => s.section).join(",")}`);
            const htmlMap = await response.json();

            sectionsToReRender.forEach(({ id, section, selector }) => {
                const newHTML = new DOMParser().parseFromString(htmlMap[section], "text/html").querySelector(selector)?.innerHTML;
                const targetElement = document.getElementById(id)?.querySelector(selector) || document.getElementById(id);
                if (newHTML && targetElement) targetElement.innerHTML = newHTML;
            });

            document.querySelector("cart-drawer").open();
        });

        const bundleFetchOverride = async () => {
            const localStorageKey = "tl-product-bundle-local-storage";

            if (!localStorage.getItem(localStorageKey)) {
                await window.tlProductBundle.initializeLocalStorage();
            }

            const currentProductId = window.tlProductBundle.currentProduct.id;
            const { rules: packageDealRules } = JSON.parse(localStorage.getItem(localStorageKey));

            const appliedPackageDealRule = packageDealRules.find((rule) => rule.listParents[0].product_id == currentProductId);

            if (!appliedPackageDealRule) return;

            const originalFetch = window.fetch;

            window.fetch = function (resource, init = {}) {
                try {
                    const url = new URL(resource, window.location.origin).pathname;

                    if (/\/cart\/add$/.test(url) && init.method === "POST") {
                        const qtyWidget = document.querySelector("#MainContent quantity-input.quantity");
                        const qtyInput = qtyWidget?.querySelector('input[name="quantity"]');
                        const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

                        const allVariants = appliedPackageDealRule.listChilds;

                        const firstVariants = [];
                        const seenProductIds = new Set();

                        for (const variant of allVariants) {
                            if (!seenProductIds.has(variant.product_id)) {
                                seenProductIds.add(variant.product_id);
                                firstVariants.push(variant);
                            }
                        }

                        const formData = {
                            items: firstVariants.map((item) => ({
                                id: item.shopify_id,
                                quantity,
                            })),
                        };

                        return originalFetch(window.Shopify.routes.root + "cart/add.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(formData),
                        }).then((response) => {
                            if (!response.ok) throw new Error("Add to cart failed");

                            const clone = response.clone();

                            clone
                                .json()
                                .then((json) => {
                                    window.dispatchEvent(
                                        new CustomEvent("TL-PRODUCTBUNDLE:add", {
                                            detail: json,
                                        }),
                                    );
                                })
                                .catch((err) => console.error("bundle event error:", err));

                            return response;
                        });
                    }
                } catch (e) {
                    console.error("[bundle-override]", e);
                }

                return originalFetch(resource, init);
            };
        };

        await bundleFetchOverride();
    }
}, 100);

setTimeout(() => {
    clearInterval(intervalId);
}, 3000);